"use client";

import { useState } from "react";
import {
  markdownEditorBlankUrl,
  markdownEditorHandoffUrl,
  stashEditorHandoff,
} from "../editor/editor-handoff";
import type { ReadMarkdownFileSuccess } from "../editor/read-markdown-file";
import { SiteFooter } from "../home/site-footer";
import { SiteHeader } from "../home/site-header";
import { MarkdownFileDropzone } from "./markdown-file-dropzone";

export function ConvertMdToPdfClient() {
  const [handoffError, setHandoffError] = useState<string | null>(null);

  function openUploadedFile(document: {
    markdown: string;
    filename: string;
  }) {
    setHandoffError(null);
    const handoffId = stashEditorHandoff(document);
    if (!handoffId) {
      setHandoffError(
        "Could not open the editor in this browser. Try pasting your Markdown on the editor page instead.",
      );
      return;
    }
    // Full navigation with a one-shot handoff id avoids cached editor state and
    // prevents re-applying the upload when returning to /markdown-editor later.
    window.location.assign(markdownEditorHandoffUrl(handoffId));
  }

  function handleLoaded(result: ReadMarkdownFileSuccess) {
    openUploadedFile({
      markdown: result.markdown,
      filename: result.filename,
    });
  }

  function handleStartBlank() {
    // Blank is URL-driven (no sessionStorage) so server and client render the
    // same empty editor and avoid a hydration mismatch.
    window.location.assign(markdownEditorBlankUrl());
  }

  return (
    <main className="flex min-h-dvh flex-col bg-zinc-100 text-zinc-950">
      <SiteHeader />
      <div className="flex flex-1 flex-col border-b border-zinc-200 bg-white">
        <MarkdownFileDropzone
          onLoaded={handleLoaded}
          onStartBlank={handleStartBlank}
        />
        {handoffError ? (
          <p
            role="alert"
            className="mx-auto max-w-xl px-4 pb-8 text-center text-sm text-red-700"
          >
            {handoffError}
          </p>
        ) : null}
      </div>
      <SiteFooter />
    </main>
  );
}
